import { Cell, FormControl, Grid } from 'bold-ui'
import {
  DateField,
  DecimalField,
  ErrorField,
  Form,
  FormPrompt,
  FormRenderProps,
  PecFormApi,
  resetAllFieldStates,
  SubmitButton,
} from 'components/form'
import { subDays } from 'date-fns'
import React from 'react'
import { toDate } from 'util/date/formatDate'
import { metaPath } from 'util/metaPath'

import { MedicaoAnteriorModel } from '../model-medicoes'
import { MedicaoAnteriorAntropometriaFormModel } from './model-medicaoAnteriorAntropometria'
import { convertMedicaoAnteriorAntropometriaFormModelToMedicaoAnteriorModel } from './utils-medicaoAnteriorAntropometria'
import { medicaoAnteriorAntropometriaValidator } from './validator-medicaoAnteriorAntropometria'

interface MedicaoAnteriorAntropometriaFormProps {
  dataAtendimento: Instant
  dataNascimentoCidadao: LocalDate
  onSubmit: (medicao: MedicaoAnteriorModel) => void
}

const meta = metaPath<MedicaoAnteriorAntropometriaFormModel>()

export function MedicaoAnteriorAntropometriaForm(props: Readonly<MedicaoAnteriorAntropometriaFormProps>) {
  const { dataAtendimento, dataNascimentoCidadao, onSubmit } = props

  const handleSubmit = (
    values: MedicaoAnteriorAntropometriaFormModel,
    form: PecFormApi<MedicaoAnteriorAntropometriaFormModel>
  ) => {
    const convertedValues = convertMedicaoAnteriorAntropometriaFormModelToMedicaoAnteriorModel(values)
    onSubmit(convertedValues)
    resetAllFieldStates(form)
    setTimeout(form.reset)
  }

  const renderForm = (renderFormProps: FormRenderProps<MedicaoAnteriorAntropometriaFormModel>) => (
    <>
      <FormPrompt />
      <Grid gap={1}>
        <Cell size={12}>
          <ErrorField type='alert' name={meta.medicoes} />
        </Cell>
        <Cell size={3}>
          <DateField
            name={meta.data}
            label='Data da medição anterior'
            minDate={toDate(dataNascimentoCidadao)}
            maxDate={subDays(toDate(dataAtendimento), 1)}
            required
          />
        </Cell>
        <Cell size={2}>
          <DecimalField name={meta.peso} label='Peso (kg)' maxLength={7} precisao={3} />
        </Cell>
        <Cell size={2}>
          <DecimalField name={meta.altura} label='Altura (cm)' maxLength={5} precisao={2} />
        </Cell>
        <Cell size={3}>
          <DecimalField name={meta.perimetroCefalico} label='Perímetro cefálico (cm)' maxLength={5} precisao={1} />
        </Cell>
        <Cell size={2}>
          <FormControl label={<span>&nbsp;</span>}>
            <SubmitButton kind='primary' handleSubmit={renderFormProps.handleSubmit} size='small'>
              Adicionar
            </SubmitButton>
          </FormControl>
        </Cell>
      </Grid>
    </>
  )

  return (
    <Form<MedicaoAnteriorAntropometriaFormModel>
      suppressNotificationError
      render={renderForm}
      validate={medicaoAnteriorAntropometriaValidator(dataAtendimento, dataNascimentoCidadao)}
      onSubmit={handleSubmit}
    />
  )
}
